import React from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ background: 'var(--bg-secondary)', borderTop: '1px solid var(--border-light)' }}>
      <div className="container" style={{ padding: '80px 40px 40px' }}>
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '48px',
          marginBottom: '48px'
        }}>
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>SOLENNE</h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
              Handcrafted luxury footwear made in Italy since 2010.
            </p>
          </div>
          
          <div>
            <h4 className="body-regular" style={{ fontWeight: 700, marginBottom: '16px' }}>Shop</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>New Arrivals</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Heels</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Boots</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Sandals</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="body-regular" style={{ fontWeight: 700, marginBottom: '16px' }}>Customer Care</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Contact Us</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Size Guide</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Shipping & Returns</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Care Instructions</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="body-regular" style={{ fontWeight: 700, marginBottom: '16px' }}>Follow Us</h4>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="#" className="btn-icon" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="btn-icon" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="btn-icon" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>
        
        <div style={{ 
          paddingTop: '32px',
          borderTop: '1px solid var(--border-light)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>
            © 2025 SOLENNE. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <a href="#" className="body-small" style={{ color: 'var(--text-light)', textDecoration: 'none' }}>Privacy Policy</a>
            <a href="#" className="body-small" style={{ color: 'var(--text-light)', textDecoration: 'none' }}>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
